import axios from 'axios';

export const accounts = {
    bt: {
        account_name: "B.T.",
        account_handle: "BTdk",
        image_url: "/img/twitter/bt.jpg",
        verified: true
    },
    borsen: {
        account_name: "Børsen",
        account_handle: "borsendk",
        image_url: "/img/twitter/borsen.jpg",
        verified: true
    },
    jp: {
        account_name: "Jyllands-Posten",
        account_handle: "jyllandsposten",
        image_url: "/img/twitter/jp.jpg",
        verified: true
    },
    politiken: {
        account_name: "Politiken",
        account_handle: "politiken",
        image_url: "/img/twitter/politiken.jpg",
        verified: true
    },
    berlingske: {
        account_name: "Berlingske",
        account_handle: "berlingske",
        image_url: "/img/twitter/berlingske.jpg",
        verified: true
    },
    eb: {
        account_name: "Ekstra Bladet",
        account_handle: "EkstraBladet",
        image_url: "/img/twitter/eb.png",
        verified: true
    },
    mette: {
        account_name: "Mette Frederiksen",
        account_handle: "mettefrederiksen",
        image_url: "/img/twitter/mette.jpg",
        verified: true
    },
    dr: {
        account_name: "DR Nyheder",
        account_handle: "DRNyheder",
        image_url: "/img/twitter/dr.png",
        verified: true
    },
    drbreaking: {
        account_name: "DR Nyheder Breaking",
        account_handle: "DRBreaking",
        image_url: "/img/twitter/drbreaking.png",
        verified: true
    },
    altinget: {
        account_name: "Altinget",
        account_handle: "Altingetdk",
        image_url: "/img/twitter/altinget.png",
        verified: true
    },
    kk: {
        account_name: "Københavns Kommune",
        account_handle: "koebenhavner",
        image_url: "/img/twitter/kk.jpg",
        verified: true
    }

    // anon: {
    //     account_name: "Anonymous",
    //     account_handle: "anonymous",
    //     image_url: "/img/twitter/anonymous.svg"
    // },
    // quest: {
    //     account_name: "Quest",
    //     account_handle: "quest",
    //     image_url: "/img/twitter/quest.svg"
    // }
}

const getRandomUsers = async () => {
    // if (language === 'da') {
    //     return axios.get(`https://randomuser.me/api/?nat=dk&results=100`).then(response => response.data.results).catch(() => [])
    // } else {
    return axios.get(`https://randomuser.me/api/?results=100`).then(response => response.data.results).catch(() => [])
    // }
}

export const randomUsers = async () => {
    const users = await getRandomUsers()
    return users.map(u => ({
        account_name: u.name.first + ' ' + u.name.last,
        account_handle: (u.name.first + ' ' + u.name.last).toLowerCase().replace(/\s/g, ''),
        image_url: u.picture.large,
        verified: false,
        random: true
    }))
}